"use client"

import { Controller, useFormContext } from "react-hook-form"
import { PostAJobModalFormValues } from "./types"
import { useLocationFilter } from "../Filters/useLocationFilter"
import { DropDownItem, TextInputWithDropdown } from "../TextInputWithDropdown"
import { useMemo } from "react"
import { InputErrorText } from "../InputErrorText"
import { uniqBy } from "lodash"

interface Props {
  displayValue: string
  onChangeDisplayValue: (value: string) => void
}

export const LocationInput: React.FC<Props> = ({ displayValue, onChangeDisplayValue }) => {
  const { control, setValue } = useFormContext<PostAJobModalFormValues>()
  const { locations } = useLocationFilter({ search: displayValue })

  const onClickDropDownItem = (item: DropDownItem) => {
    if (item.display === "Remote") {
      setValue("remote", true)
      setValue("location", {
        lat: "",
        lon: "",
        name: "",
      })
      onChangeDisplayValue("Remote")
    } else {
      setValue("remote", false)
      setValue("location", {
        lat: item.lat!,
        lon: item.lon!,
        name: item.display!,
      })
      onChangeDisplayValue(item.display)
    }
  }

  const dropDownItems = useMemo(() => {
    const results =
      locations
        ?.map(loc => {
          return {
            display: loc.name!,
            lat: loc.lat!,
            lon: loc.lon!,
          }
        })
        .slice(0, 4) || []

    return uniqBy(
      [
        {
          display: "Remote",
        },
        ...results,
      ],
      "display"
    )
  }, [locations])

  return (
    <Controller
      name="location.name"
      control={control}
      rules={{
        validate: (value, formValues) => {
          if (!formValues.remote && !value) {
            return "A location is required"
          }
          return true
        },
      }}
      render={({ field, fieldState: { error } }) => (
        <div className="flex flex-1 flex-col">
          <TextInputWithDropdown
            size="large"
            showMenuWithoutValue
            closeMenuOnSelect
            dropDownClassName="max-h-[220px] overflow-scroll"
            id="location-input"
            inputValue={displayValue}
            dropdownItems={dropDownItems}
            inputProps={{
              placeholder: "Location",
              className: "text-primary-3 w-full",
              onChange: e => {
                setValue("remote", false)
                setValue("location", {
                  lat: "",
                  lon: "",
                  name: "",
                })
                onChangeDisplayValue(e.target.value)
              },
            }}
            onClickDropDownItem={onClickDropDownItem}
          />
          {error?.message && <InputErrorText text={error.message} />}
        </div>
      )}
    />
  )
}
